// PGDesign
import React, { FC } from 'react';
import Comma from '../../components/Comma';
import { Image } from '../../components/Image';

import styles from './PGDesign.module.scss';

interface Props {
  PGDesignData: { [key: string]: string };
}
const PGDesign: FC<Props> = (props) => {
  const { PGDesignData } = props;
  return (
    <section className={styles['pg-design-box']}>
      <h2 className={styles['design-title']}>{PGDesignData.title}</h2>
      <div className={styles['design-intro-box']}>
        <p className={styles['design-intro']}>{PGDesignData.introText1}</p>
        <span className={styles['comma-box']}>
          <Comma />
        </span>
        <p className={styles['design-intro']}>{PGDesignData.introText2}</p>
      </div>
      <div className={styles['design-img-box']}>
        <Image src={PGDesignData.img} layout="responsive" width={1024} height={609} />
      </div>
    </section>
  );
};

PGDesign.displayName = 'PGDesign';
export default PGDesign;
